import { Component } from 'react';
import Sortable from './Sortable/Sortable';
import { userStore } from 'src/mobx/userStore';
import player from 'src/services/audio';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CopyButton from 'src/view/components/Controls/CopyButton/CopyButton';
import Text, { TEXT } from 'src/view/components/Text/Text';
import Icon from '~/view/components/Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';

export default class GuidelineScreen extends Component<{}, {}> {
  state = {
    //
  };

  onTestClick = () => {
    //
  };

  render() {
    return (
      <div className="d-flex flex-column gap-30">
        <Button title="Play sound for 5s" onClick={() => player.play(5000)} />
        <Button title="click" onClick={this.onTestClick} />
        <div className="d-flex flex-column mb-4">
          <Icon name={Icons.IcDook} size={35} color={theme.colors.mainblue} />
          <Text type={TEXT.CUSTOM} text={`USER FIREBASE TOKEN: ${userStore.firebase_token || 'None'}`} className="text-size-24" />
          {userStore.firebase_token ? <CopyButton data={userStore.firebase_token} /> : null}
        </div>

        <Sortable />
      </div>
    );
  }
}
